import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import translations from '../../translations/i18next';
import { Refresh } from '@material-ui/icons';

const RetryAIButton = ({ onClick, color, fontSize }) => {
  return (
    <Tooltip title={translations.t('chat.retry')} placement="bottom" arrow>
      <IconButton onClick={onClick} style={{ margin: 0, padding: 0, marginLeft: 2 }}>
        <Refresh fontSize="small" style={{ color, fontSize }} />
      </IconButton>
    </Tooltip>
  );
};

export default RetryAIButton;
